import { useState, useRef, useEffect } from "react";

import { upArrow } from 'utils';
import { useAppContext } from "contexts/AppContext";
import Head from 'next/head';
import Link from 'next/link';
import XoMedia from "@/components/modules/XoMedia/XoMedia";
import AboutNavigation from "@/components/modules/AboutNavigation/AboutNavigation";
import SingleTestimonial from "@/components/modules/SingleTestimonial/SingleTestimonial";
import Button from "@/components/elements/Button/Button";
import SimplePlayer from "@/components/elements/SimplePlayer/SimplePlayer";
import DotDivider from "@/components/elements/DotDivider/DotDivider";
import styles from '../styles/About.module.scss';


const testimonials = [
    {
        quote: <q>
            As a woman who has experienced trauma around sex earlier in life (and a lot of shame around sex, too) <b>I have been looking for porn that is exciting without the &#34;ick&#34; factor. Afterglow is IT!</b> Their videos are sexy and don&#39;t make me feel cringey afterwards. Highly, highly recommend to anyone looking to get turned on!
        </q>,
        customer: "-Leigh, 29, San Francisco",
        color: "blue"
    },
    {
        quote: <q>
            <b>This felt like it was taken straight from my fantasies! It was beautiful and sexy and the interview with the stars after was so endearing and made me feel like what I saw in the film was authentic. I can enjoy it even more knowing the performers were enjoying their experience. Also the couple could not be more attractive, my GOD!</b>
        </q>,
        customer: "-Teagan, 24, Los Angeles, about the Afterglow film, Lipservice",
        color: "rose"
    },
]


const About = () => {

    const { isMobile } = useAppContext()

    const founderRef = useRef()
    const subscriptionRef = useRef()
    const mythsRef = useRef()
    const testimonialsRef = useRef()
    const signupRef = useRef()
    const topRef = useRef()
    const [showArrow, setShowArrow] = useState()
    const location = "About us section"

    // /NEXTFILE
    const trailer = {
        id: 1, title: "Lilly about us", placeholder: "/next/About Video Thumbnail.webp", route: "about-us"
    }

    useEffect(()=>{
        window.addEventListener('scroll', handleUpArrow);
        return () => {
            window.removeEventListener('scroll', handleUpArrow);
        };
    }, [])

    function handleUpArrow(){
        (window.pageYOffset > 300) ? setShowArrow(true) : setShowArrow(false)
    }



    return (
        <>
        <Head>
            <title>About | afterglow</title>
        </Head>
        <div className={styles.about} ref={topRef}>
            <div className={`${styles.up} ${!showArrow ? styles['up-hidden'] : ''}`} onClick={()=>topRef.current.scrollIntoView({behavior: "smooth"})}>
                {upArrow()}
            </div>
            <main>
                <section className={styles.section} style={{position: "relative"}}>
                    <h1 className={`${styles.sectionTitle} ${styles['about-top-h1-text']}`}>
                        How porn should be
                    </h1>
                    <h2 className="about-top-h2-text">
                    Ethical Porn • Made by women • Guided masturbations • Partner exercises •  Behind the scenes content
                    </h2>

                    <AboutNavigation sections={[founderRef, subscriptionRef, mythsRef, testimonialsRef]} signupRef={signupRef} />

                </section>
                <XoMedia />

                <section className={styles.section} style={{paddingTop: "80px"}}>
                    <SingleTestimonial testimonial={testimonials[0]} />
                </section>

                <section className={`${styles.section} ${styles['section-dark']}`} ref={founderRef} id="meet-the-founder">
                    <h2 className={styles.sectionTitle} style={{fontWeight: "normal", marginBottom: "16px"}}>
                    60% of women are dissatisfied with their sex life. And I was one of them...
                    </h2>

                    <div className={styles.heroVideo}>
                        <SimplePlayer video={trailer} controls={true} />
                    </div>
                </section>

                <section className={styles.section}>
                    <h3 className={styles.sectionTitle}>When you think of porn today, what do you think of?</h3>
                    <div className={`${styles.dividerGlow}`} style={{marginTop: 0}}></div>
                    <p>Probably opening an incognito window on your computer, being bombarded with graphic ads, or searching endlessly for a film that doesn’t involve typical teen, MILF, or stepsibling tropes. </p>
                    <p>
                        <b>You don’t know how the film was made or how the actors were hired, treated, or paid. The second you’re done, you’re pushing your computer away, trying to forget what you saw.</b>
                    </p>
                    <p>
                    Let me tell you, <b>it doesn’t have to be that way.</b>
                    </p>
                </section>

                <section className={`${styles.section} ${styles['section-dark']}`} style={{paddingTop: "80px"}}>
                    <SingleTestimonial testimonial={testimonials[1]} backgroundColor="#1f1e1c" />
                </section>

                <section className={styles.section}>
                    <h3 className={styles.sectionTitle}>The porn you’ve been waiting for is here. <br/> It’s ethical. And it’s sexy as fuck.</h3>
                    <span className={styles.ctaBtn}>
                    <Link href="/signup" passHref>
                        <span>
                            <Button tracking={{destination:"/signup", location}}>
                                Sign Me Up
                            </Button>
                        </span>
                    </Link>
                    </span>
                    <p className={styles['about-subheader-p-text']} style={{marginTop: "32px"}}>
                        <b className={styles['about-subheader-heading-text']}>Plus, afterglow isn’t only porn.<br></br> </b> It’s partner exercises, guided masturbations, and behind the scenes content. It’s sexual wellness. It’s a diversity of bodies, people, and relationship types. And it’s here to make your sex life better.
                    </p>
                </section>

                <section className={`${styles.section} ${styles['section-white']}`} ref={subscriptionRef} id="subscription-info">
                    <h3 className={styles.sectionTitle}>Your afterglow subscription gets you intimate access to:</h3>

                    <div className={styles.accessList}>
                        <ul>
                            <li>Porn that centers your pleasure, without the ick</li>
                            <li>No annoying pop-ups</li>
                            <li>Exclusive, behind the scenes interviews with performers and filmmakers</li>
                            <li>Guided masturbations for bigger, better orgasms</li>
                            <li>Partner exercises to improve communication, intimacy, and sex</li>
                            <li>And more. Tell us what you’re craving, and we might just bring your fantasy to the big screen</li>
                        </ul>
                    </div>
                </section>

                <section className={styles.section}>
                    <p>
                        <b>You don’t have to search to find a body that looks like yours, a sex act that turns you on, a performer who seems real, or a guided exercise that helps you tell your partner exactly what you’ve been craving.</b>
                    </p>
                    <div className={`${styles.dividerGlow}`} style={{marginTop: 0}}></div>
                    <p>Whatever your pleasure or fantasy looks like, there’s something for you at afterglow.</p>

                    <div className={styles.QNA}>
                        <ul>
                            <li>Lesbian porn? Yes please.</li>

                            <li>Gang bangs? Bring it on.</li>

                            <li>Queer performers? Absolutely.</li>

                            <li>Soft and slow sex acts? Mhmm.</li>

                            <li>Partner exercises? We’ve got you.</li>

                            <li>Guided masturbations? You already know the answer.</li>
                        </ul>
                    </div>
                    <p>No questions about whether the actors are enjoying themselves, being paid fairly, and 18+ years old.</p>

                    <span className={styles.ctaBtn} style={{marginBottom: 0}}>
                        <Link href="/signup" passHref>
                            <span>
                                <Button tracking={{destination:"/signup", location}}>
                                    Take me to afterglow
                                </Button>
                            </span>
                        </Link>
                    </span>
                </section>

                <section className={`${styles.section} ${styles['section-dark']}`} ref={mythsRef} id="porn-myths">

                    <h3 className={styles.sectionTitle}>There’s a lot of misinformation about the porn industry</h3>
                    <div className={`${styles.dividerGlow}`} style={{marginTop: 0}}></div>
                    <p>And that misinformation? It gets in the way of people having better sex, exploring their sexual wellness, and supporting sex workers.</p>

                    <div className={styles.mythBusting}>
                        <h4 className={`${styles.sectionTitle} ${styles['myth-section-top-heading-h4']}`}>
                        So let’s bust some myths, shall we?
                        </h4>

                        <ul>
                            <li>
                                <div className={styles.mythTitle}>
                                    <b>
                                        <span>
                                        Myth 1: Porn is bad for you
                                        </span>                                     
                                    </b>
                                </div>
                                <p><b>Watching porn is actually correlated with increased sexual satisfaction,</b> greater desire and arousal during partnered sex, and MORE ORGASMS (which have a myriad of health benefits, by the way)</p>
                            </li>
                            <li>
                                <div className={styles.mythTitle}>
                                    <b>
                                        <span>
                                        Myth 2: Women don’t watch porn
                                        </span>         
                                    </b>
                                </div>
                                <p>Pffft.<b> 73% of women have watched porn in the past six months.</b> 💅🏾 What else you got?</p>
                            </li>
                            <li>
                                <div className={styles.mythTitle}>
                                    <b>
                                        <span>
                                        Myth 3: Ethical porn does not exist
                                        </span>                                 
                                    </b>
                                </div>
                                <p>When you subscribe to afterglow, you can trust that <b>we’re committed to ethical standards including fair pay, a safe environment, and transparency.</b> We’re here to create a safe place for sex on the internet (which includes protecting your privacy. Read our <a href="/privacy-policy" className={styles.blue} aria-label="Privacy policy">privacy policy</a>.</p>
                            </li>
                        </ul>
                    </div>

                    <h3 className={`${styles.sectionTitle} ${styles['sectionTitle-big']}`} style={{margin: "30px 0 0 0"}}>The truth about porn? it’s normal, it’s common, and it’s good for you</h3>
                    <div className={`${styles.divider} ${styles['divider-white']}`}></div>
                    <h3 className={styles.sectionTitle} style={{fontWeight: "normal", margin: "0 0 30px 0"}}>
                    Our mission is simple: to inspire great sex
                    </h3>
                    <div className={`${styles.dividerGlow}`} style={{marginTop: 0}}></div>

                    <p>We want everyone to experience more pleasure. To feel lit up in their lives. And to know that their desires are beautiful, unique, and worthy of being fulfilled</p>
                </section>

                <section className={styles.section}>
                    <h3 className={styles.sectionTitle}>What are the ingredients for great sex? We think it boils down to three things:</h3>
                    {isMobile &&
                        <DotDivider />
                    }
                    <div className={styles.boilsDownTo}>
                        <ul>
                            <li>1) Reducing shame and stigma</li>
                            <li>2) Creating safe spaces (yes, even for gang bang fantasies)</li>
                            <li>3) Learning you can trust yourself, lean into your hell yes, and communicate what you want</li>
                        </ul>
                    </div>
                    {isMobile &&
                        <DotDivider />
                    }
                    <Link href="/signup" passHref>
                        <span>
                            <Button tracking={{destination:"/signup", location}}>
                                I want great sex
                            </Button>
                        </span>
                    </Link>
                </section>

                <section className={`${styles.section} ${styles['section-white']}`} ref={testimonialsRef} id="testimonials">
                    <h3 className={styles.sectionTitle}>“I’ve been looking for this for FOREVER”</h3>
                    <p style={{marginBottom: "0px"}}>Here’s what some of our members have to say about afterglow</p>
                    <div className={styles.divider}></div>
                    <div className={styles.membersSay}>
                        <ul style={{marginTop: "0px"}}>
                            <li>
                                <div>
                                    <b>
                                        <q>
                                            <b>I&#39;m finding the power in my own skin precisely because I can find my own pleasure.</b>
                                        </q>
                                    </b>
                                </div>
                                <div>
                                -Sabrina, 35, Boston
                                </div>
                            </li>
                            <li>
                                <div>
                                    <b>
                                        <q>
                                            <b>afterglow has brought me and my partner closer together.</b> It’s really changed our relationship. He’s opened up a lot more. I can send him a new Afterglow video and it&#39;s fun and it takes the shame out of masturbating and porn.
                                        </q>
                                    </b>
                                </div>
                                <div>
                                -Maria, 24, New York
                                </div>
                            </li>
                            <li>
                                <div>
                                    <b>
                                        <q>
                                            <b>Becoming more sex positive and tapping into my sexuality and sensuality has helped me like myself better. I&#39;m just happier.</b>
                                        </q>
                                    </b>
                                </div>
                                <div>
                                -Rae, 28, Los Angeles
                                </div>
                            </li>
                        </ul>
                    </div>
                </section>

                <section className={`${styles.section} ${styles['section-dark']} ${styles['sectionHellYes']}`}>
                    <h3 className={styles.sectionTitle}>Ready for more hell yes in your life?</h3>
                    <div className={`${styles.dividerGlow}`} style={{marginTop: 0}}></div>
                    <p style={{marginBottom: "0px"}}><b>Start your subscription today. Feel good about your porn. Feel good about your pleasure.</b></p>
                    <div className={styles.ctaBtn}>
                    <Link href="/signup" passHref>
                        <span>
                            <Button tracking={{destination:"/signup", location}}>
                                Pleasure, please
                            </Button>
                        </span>
                    </Link>
                    </div>
                </section>

            </main>
        </div>
        </>
     );
}

export default About;
